var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ObjectiveSectionLayout",
    {
      scopedSlots: _vm._u([
        {
          key: "icon",
          fn: function() {
            return [
              _c("CompassIcon", {
                attrs: { size: "large", icon: "obj-nb-yellow-1" }
              })
            ]
          },
          proxy: true
        },
        {
          key: "title",
          fn: function() {
            return [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$l10n.__("Définissez votre objectif")) +
                  "\n    "
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          staticClass: "objective-define__field",
          attrs: {
            label: _vm.$t.__(
              "objectives.create.section.ObjectiveSectionDefine.category"
            )
          }
        },
        [
          _c(
            "CompassSelect",
            {
              staticClass: "objective-type__selector",
              attrs: { disabled: _vm.isDuplicateForm },
              model: {
                value: _vm.category,
                callback: function($$v) {
                  _vm.category = $$v
                },
                expression: "category"
              }
            },
            _vm._l(_vm.objectiveTypes, function(objectiveType) {
              return _c("CompassDropdownSelectOption", {
                key: objectiveType.code,
                attrs: {
                  label: _vm.getCategoryLabel(objectiveType.code),
                  value: objectiveType.code
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          staticClass: "objective-define__field",
          attrs: {
            label: _vm.$t.__(
              "objectives.create.section.ObjectiveSectionDefine.name"
            ),
            error: _vm.errors && _vm.errors.get("name")
          }
        },
        [
          _c("CompassInput", {
            attrs: {
              placeholder: _vm.$t.__(
                "objectives.create.section.ObjectiveSectionDefine.name_placeholder"
              ),
              error: _vm.errors && _vm.errors.has("name")
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          staticClass: "objective-define__field",
          class: {
            "objective-define__field--multiple": ["staff", "group"].includes(
              _vm.owner
            )
          },
          attrs: {
            label: _vm.$t.__(
              "objectives.create.section.ObjectiveSectionDefine.assignee"
            ),
            error:
              _vm.errors &&
              (_vm.errors.get("assignee.type") || _vm.errors.get("assignee.id"))
          }
        },
        [
          _c(
            "CompassSelect",
            {
              staticClass: "objective-owner__selector",
              attrs: { disabled: !_vm.canChooseOwnerWithUpsell },
              model: {
                value: _vm.owner,
                callback: function($$v) {
                  _vm.owner = $$v
                },
                expression: "owner"
              }
            },
            _vm._l(_vm.owners, function(ownerOption) {
              return _c(
                "CompassDropdownSelectOption",
                {
                  key: ownerOption.code,
                  attrs: {
                    label: _vm.getAssigneeTypeLabel(ownerOption.code),
                    value: ownerOption.code,
                    disabled: _vm.hasUpsell(ownerOption.code)
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.getAssigneeTypeLabel(ownerOption.code)) +
                      "\n                "
                  ),
                  _vm.hasUpsell(ownerOption)
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "objective-owner__selector--upsell-badge",
                          on: {
                            click: function($event) {
                              return _vm.openFeatureModal(
                                ownerOption.upsell.data
                              )
                            }
                          }
                        },
                        [
                          _c("CompassFeatureBadge", {
                            attrs: { size: "small", variant: "upsell" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          ["group", "staff"].includes(_vm.owner)
            ? _c(
                "CompassSelect",
                {
                  key: "exactOwner-select-" + _vm.exactOwnerSelectKey,
                  attrs: {
                    filterable: true,
                    actions: _vm.actions,
                    error: _vm.errors.has("assignee.id"),
                    disabled: !_vm.canChooseOwner
                  },
                  model: {
                    value: _vm.exactOwner,
                    callback: function($$v) {
                      _vm.exactOwner = $$v
                    },
                    expression: "exactOwner"
                  }
                },
                _vm._l(_vm.exactOwnersList, function(exactOwnerOption) {
                  return _c("CompassDropdownSelectOption", {
                    key: exactOwnerOption.value,
                    attrs: {
                      label: exactOwnerOption.label,
                      value: parseInt(exactOwnerOption.value)
                    }
                  })
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.canSelectItems || _vm.hasUpsell(_vm.settings.metadata.choose_product)
        ? _c(
            "CompassFormItem",
            {
              staticClass:
                "objective-define__field objective-define__field-product--switch",
              class: _vm.productSwitchClass,
              attrs: { label: "" }
            },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    disabled: _vm.hasItems,
                    placement: "bottom-start",
                    content: _vm.$t.__(
                      "objectives.create.section.ObjectiveSectionDefine.no_product"
                    ),
                    contentClass: "badge-tooltip"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "objective-define__field-product--switch-content"
                    },
                    [
                      _c("CompassSwitch", {
                        attrs: {
                          value: _vm.hasItems && _vm.openSelectItems,
                          label: _vm.$t.__(
                            "objectives.create.section.ObjectiveSectionDefine.create_for_a_product"
                          ),
                          disabled:
                            !_vm.hasItems ||
                            _vm.hasUpsell(_vm.settings.metadata.choose_product),
                          orientation: "left"
                        },
                        on: { change: _vm.toggleProduct }
                      }),
                      _vm._v(" "),
                      _vm.hasUpsell(_vm.settings.metadata.choose_product)
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "objective-define__field-product--switch-upsell-badge",
                              on: {
                                click: function($event) {
                                  return _vm.openFeatureModal(
                                    _vm.settings.metadata.choose_product.upsell
                                      .data
                                  )
                                }
                              }
                            },
                            [
                              _c("CompassFeatureBadge", {
                                attrs: { size: "small", variant: "upsell" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.hasItems && _vm.openSelectItems
                ? _c(
                    "CompassRadioGroup",
                    {
                      staticClass:
                        "objective-define__field-product--radio-group",
                      attrs: {
                        value: _vm.value.itemsType,
                        direction: "horizontal"
                      },
                      on: { input: _vm.changeType }
                    },
                    [
                      _vm.hasProducts
                        ? _c("CompassRadio", {
                            attrs: {
                              modelValue: "product",
                              label: _vm.$t.__(
                                "objectives.create.section.ObjectiveSectionDefine.for_product_or_service"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasCategories
                        ? _c("CompassRadio", {
                            attrs: {
                              modelValue: "category",
                              label: _vm.$t.__(
                                "objectives.create.section.ObjectiveSectionDefine.for_product_category"
                              )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.openSelectItems && _vm.isProductItemsType && _vm.hasProducts
        ? _c(
            "CompassFormItem",
            {
              staticClass: "objective-define__field",
              attrs: {
                label: _vm.$t.__(
                  "objectives.create.section.ObjectiveSectionDefine.product_or_service"
                ),
                error: _vm.errors && _vm.errors.get("itemId")
              }
            },
            [
              _c("CompassAutoComplete", {
                attrs: {
                  results: _vm.results,
                  noResultsLabel: _vm.$t.__(
                    "objectives.create.section.ObjectiveSectionDefine.no_result"
                  ),
                  placeholder: _vm.$t.__(
                    "objectives.create.section.ObjectiveSectionDefine.search_product_or_service"
                  ),
                  loading: _vm.loading,
                  error: _vm.errors && _vm.errors.has("itemId")
                },
                on: {
                  change: _vm.handleSelectedItem,
                  "update-search": _vm.autoCompleteResults
                },
                model: {
                  value: _vm.itemSelected,
                  callback: function($$v) {
                    _vm.itemSelected = $$v
                  },
                  expression: "itemSelected"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.openSelectItems && _vm.isCategoryItemsType && _vm.hasCategories
        ? _c(
            "CompassFormItem",
            {
              staticClass: "objective-define__field",
              attrs: {
                label: _vm.$t.__(
                  "objectives.create.section.ObjectiveSectionDefine.product_category"
                ),
                error: _vm.errors && _vm.errors.get("itemCategoryId")
              }
            },
            [
              _c(
                "CompassSelect",
                {
                  attrs: {
                    filterable: "",
                    error: _vm.errors && _vm.errors.has("itemCategoryId")
                  },
                  model: {
                    value: _vm.itemId,
                    callback: function($$v) {
                      _vm.itemId = $$v
                    },
                    expression: "itemId"
                  }
                },
                _vm._l(_vm.categoriesList, function(category) {
                  return _c("CompassDropdownSelectOption", {
                    key: "item_category-" + category.code,
                    attrs: {
                      label: category.label,
                      value: parseInt(category.code)
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.showPopup,
            size: "small",
            title: _vm.ownerToCreateDialogLabels.title
          },
          on: {
            "update:visible": function($event) {
              _vm.showPopup = $event
            },
            closed: function($event) {
              _vm.showPopup = false
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "objective-define-dialog__footer" },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.cancel"),
                          type: "secondary"
                        },
                        on: {
                          click: function($event) {
                            _vm.showPopup = false
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.ownerToCreateDialogLabels.action,
                          type: "primary-destructive"
                        },
                        on: { click: _vm.goToSettings }
                      })
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "objective-define-dialog__body" }, [
            _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.ownerToCreateDialogLabels.content) +
                  "\n            "
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }